// library imports
import React from "react";
import ReactDOM from "react-dom/client";
import { ConfigProvider, message, notification } from "antd";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
// style imports
import "./styles/index.css";
// config imports
import { route_basename } from "./configs/configs";
// context imports
import { IndexContext } from "./context/IndexContext";
// hook imports
import useThemeSwitcher from "./hooks/useThemeSwitcher";
// component/page imports
import MainLayout from "./layout/MainLayout";
import SopPage from "./pages/sop/SopPage";
import DashboardPage from "./pages/dashboard/DashboardPage";
import LoginPage from "./pages/login/LoginPage";
import UserProfilePage from "./pages/account/UserProfilePage";
import ChangePassword from "./pages/account/ChangePassword";
import EmissionDataEntry from "./pages/data_entry/EmissionDataEntry";
import AbatementDataEntry from "./pages/data_entry/AbatementDataEntry";
import ConfigurationPage from "./pages/configuration/ConfigurationPage";
import ReportPage from "./pages/reports/ReportPage";
import SummaryReportPage from "./pages/reports/SummaryReportPage";

const App = () => {
  // load theme switcher
  const [appTheme, updateTheme, isLightTheme] = useThemeSwitcher();

  // for triggering message
  const [messageApi, messageApiContext] = message.useMessage();

  // for triggering notification
  const [notificationApi, notificationApiContext] =
    notification.useNotification();

  return (
    <ConfigProvider theme={{ ...appTheme }}>
      {messageApiContext}
      {notificationApiContext}
      <IndexContext.Provider
        value={{
          messageApi: messageApi,
          notificationApi: notificationApi,
          isLightTheme: isLightTheme,
          updateTheme: updateTheme,
        }}
      >
        <BrowserRouter basename={route_basename}>
          <Routes>
            {/* Login Route */}
            <Route path="login" element={<LoginPage />}></Route>
            {/* All content pages */}
            <Route element={<MainLayout updateTheme={updateTheme} />}>
              <Route path="SOP" element={<SopPage />}></Route>
              <Route path="Dashboard" element={<DashboardPage />}></Route>
              {/* Sub route for Data Entry */}
              <Route path="DataEntry">
                <Route path="*" element={<Navigate to="Emission" />} />
                <Route path="" element={<EmissionDataEntry />} />
                <Route path="Emission" element={<EmissionDataEntry />} />
                <Route path="Abatement" element={<AbatementDataEntry />} />
              </Route>
              {/* Route for Configuration Page */}
              <Route
                path="Configuration"
                element={<ConfigurationPage />}
              ></Route>
              {/* Sub route for Report Page */}
              <Route path="Reports">
                <Route path="GhgReport" element={<ReportPage />} />
                <Route path="SummaryReport" element={<SummaryReportPage />} />
              </Route>
              {/* Sub route for Account */}
              <Route path="Account">
                <Route path="UserProfile" element={<UserProfilePage />}></Route>
                <Route
                  path="ChangePassword"
                  element={<ChangePassword />}
                ></Route>
              </Route>
            </Route>
            {/* Default all unknown route to login page */}
            <Route path="*" element={<Navigate to="/login" />} />
          </Routes>
        </BrowserRouter>
      </IndexContext.Provider>
    </ConfigProvider>
  );
};

ReactDOM.createRoot(document.getElementById("root")).render(<App />);
